<template>
      <SectionTitle 
      v-if="area_is_show == '1'"
      mainTitle="九点半"
      subTitle="资讯动态"
    />
    <div class="news-tab-section" v-if="area_is_show == '1'">
      <!-- Tab切换按钮 -->
      <div class="tab-buttons" v-if="!isMobile">
        <button 
          v-for="(tab, index) in tabs" 
          :key="index"
          class="tab-button"
          :class="{ 'active': currentTab === index }"
          @click="handleTabClick(index)"
        >
          {{ tab.name }}
        </button>
      </div>
  
      <!-- 内容区域 -->
      <div class="content-container">
        <swiper 
        ref="swiperRef" 
        :slides-per-view="slidesPerView" 
        :space-between="15" 
        @slideChange="onSlideChange"
        :loop="false"
        @swiper="onSwiperInit"
        >
          <swiper-slide 
            v-for="(tab, index) in tabs" 
            :key="index"
            class="tab-content"
          >
            <div class="content-layout" :class="{ 'mobile-layout': isMobile }">
              <!-- 左侧大图 -->
              <div class="featured-news">
                <a :href="`/content/id/${tab.newsList[0].id}`" class="image-wrapper">
                  <BaseImage 
                    :src="tab.newsList[0].image" 
                    :alt="tab.newsList[0].title"
                    class="featured-image"
                  />
                </a>
              </div>
             
  
              <!-- 右侧新闻列表 -->
              <div class="news-list" v-if="!isMobile">
                <a 
                  v-for="(news, newsIndex) in tab.newsList" 
                  :key="newsIndex"
                  :href="`/content/id/${news.id}`"
                  class="news-item"
                >
                  <div class="news-item-content">
                    <h3 class="text-ellipsis">{{ news.title }}</h3>
                    <p class="text-ellipsis" v-html="news.content"></p>
                  </div>
                  <span class="date">{{news.date}}</span>
                </a>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="carousel-indicators" v-if="isMobile">
          <span 
            v-for="(_, index) in tabs" 
            :key="index"
            :class="{ 'active': currentIndex === index }"
          ></span>
        </div>
        <div class="news-list" v-if="isMobile">
          <div 
            v-for="(news, newsIndex) in newsList" 
            :key="newsIndex"
            class="news-item"
          >
          <a 
          :href="`/content/id/${news.id}`" 
          class="news-item-content"
        >
          <h3 class="text-ellipsis">{{ news.title }}</h3>
          <p class="text-ellipsis">{{ news.content }}</p>
          <span class="tabs">{{ news.type_info }}</span>
          <span class="date">{{ news.date }}</span>
        </a>
          </div>
        </div>
      </div>
        <!-- 了解更多资讯链接 -->
        <a class="more-info-link" href="/list">了解更多资讯 &gt;</a>
    </div>
  </template>
  
  <script>
    import { htmlToText } from 'html-to-text';
    import { ref, computed, onMounted, onUnmounted } from 'vue'
    import BaseImage from '@/components/common/BaseImage.vue'
    import SectionTitle from '@/components/common/SectionTitle.vue'
    import { homeApi } from '@/api/home'
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/swiper-bundle.css';
    
    export default {
      name: 'NewsTab',
      components: {
        BaseImage,
        SectionTitle,
        Swiper,
        SwiperSlide
      },
      // props: {
      //   tabs: {
      //     type: Array,
      //     required: true
      //   }
      // },
      data() {
        return {
          tabs:[],
          currentTab: 0,
          isMobile: false,
          startX: 0,
          isDragging: false,
          currentTranslate: 0,
          area_is_show: '0',
          swiper: null,
          swiperInstance: null, // 用于存储 Swiper 实例
          slidesPerView:1,
          newsList:[],
          currentIndex: 0,
        }
      },
      computed: {

        contentStyle() {
          return {
            transform: `translateX(-${this.currentTab * 100}%)`,
            transition: 'transform 0.5s ease'
          }
        },
        wrapperStyle() {
          return {
            transform: `translateX(${-this.currentTab * (this.isMobile ? 33.333 : 33.333)}%)`,
            transition: this.isDragging ? 'none' : 'transform 0.4s ease'
          }
        }
      },
     
      methods: {
        async fetchProNews(page) {
          try {
            const response = await homeApi.getNewsList(page);
            // console.log('News Data:', response.data);
            this.newsList = response.data.slice(0, 5).map(news => {
              return {
                ...news,
                date: news.update_time.split(' ')[0] // 只取日期部分
              };
            });
          } catch (error) {
            console.error('fetchProNews Error:', error);
            this.newsList = []; // 出现错误时，设置为空数组
          }
        },
        updateSlidesPerView() {
          this.slidesPerView = window.innerWidth < 768 ? 1.1 : 1; // 根据窗口宽度设置 slidesPerView
        },

        onSwiperInit(swiper) {
          this.swiperInstance = swiper; // 存储 Swiper 实例
        },
        handleTabClick(index) {
          this.currentTab = index; // 切换当前标签
          this.$nextTick(() => {
            if (this.swiperInstance) {
              this.swiperInstance.slideTo(index); // 滚动到对应的分类
            } else {
              console.error('Swiper instance is not available');
            }
          });
        },
        onSlideChange(swiper) {
          this.currentTab = swiper.activeIndex; // 更新当前标签索引
          this.currentIndex = swiper.activeIndex; // 更新当前索引
        },
        extractTextFromHtml(html) {
          return htmlToText(html, {
            wordwrap: 130, // 设置换行
            // selectors: [
            //   { selector: 'img', format: 'skip' }, // 跳过 <img> 标签
            //   { selector: 'p', format: 'text' },   // 保留 <p> 标签的文本
            //   { selector: 'strong', format: 'text' }, // 保留 <strong> 标签的文本
            //   // 你可以根据需要添加更多的选择器
            // ]
          });
        },
        handleNewsClick(id){
          // console.log(id)
          this.$router.push(`/content/id/${id}`);
        },
        extractText(html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fullText = doc.body.innerText; // 提取纯文本
          this.cleanedContent = fullText.substring(0, 50); // 取前50个字符
        },
        async fetchNewsData() {
          try {
            const response = await homeApi.getOffcial()  // 假设这是获取新闻数据的 API 方法
            // console.log('News Data:', response.data)
            const list = response.data.list
            const tabs = []
            this.area_is_show = response.data.official_whole_block_show
            // console.log('222',response.data.official_whole_block_show)

            // 遍历每个分类
            for (const category in list) {
              if (list.hasOwnProperty(category)) {
                tabs.push({
                  name: category,
                  newsList: list[category].slice(0, 5).map(news => {
                    // 使用 DOMParser 解析 HTML
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(news.content, 'text/html');

                    // 移除所有 <img> 标签
                    const imgElements = doc.querySelectorAll('img');
                    imgElements.forEach(img => img.remove());

                    // 获取处理后的 HTML 字符串
                    const extractedText = doc.body.innerText; // 提取纯文本
                    const cleanedContent = extractedText === "" ? news.title : extractedText.substring(0, 50); // 如果提取的文本为空，则使用标题
                    return {
                      id: news.id,
                      title: news.title,
                      content: cleanedContent, // 使用处理后的内容
                      image: news.pic,
                      date: (news.update_time).split(' ')[0]
                    };
                  })
                })
              }
            }

            this.tabs = tabs; // 取前四个
            // console.log('tabs',this.tabs)

          } catch (error) {
            console.error('Error fetching news data:', error)
            this.tabs = []
          }
        },
       
        checkMobile() {
          this.isMobile = window.innerWidth <= 768
        },
        goTo930pm() {
          this.$router.push('/list')
        },
        handleTouchStart(e) {
          if (!this.isMobile) return
          this.isDragging = true
          this.startX = e.touches[0].clientX
          this.currentTranslate = -this.currentTab * 85 // 85vw
        },
        handleTouchMove(e) {
          if (!this.isMobile || !this.isDragging) return
          e.preventDefault()
        },
        handleTouchEnd(e) {
          if (!this.isMobile) return
          this.isDragging = false
          
          const endX = e.changedTouches[0].clientX
          const diff = endX - this.startX
          
          // 确定滑动方向和是否需要切换
          if (Math.abs(diff) > 50) { // 滑动距离阈值
            if (diff > 0 && this.currentTab > 0) {
              // 向右滑，切换到前一个
              this.currentTab -= 1
            } else if (diff < 0 && this.currentTab < this.tabs.length - 1) {
              // 向左滑，切换到后一个
              this.currentTab += 1
            }
          }
        },
      },

      mounted() {
        this.fetchProNews(1)
        this.updateSlidesPerView(); // 初始化时设置 slidesPerView
        this.fetchNewsData()
        this.checkMobile()
        window.addEventListener('resize', this.checkMobile)
      },
      beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile)
      },
    }
    </script>
  
  <style>
  .news-tab-section {
    width: 1366px;
    max-width: 1680px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 60px;
  }
  
  /* Tab按钮样式 */
  .tab-buttons {
    display: flex;
    justify-content: center;
    gap: 30px;
    width: 50%;
    margin: 0 auto;
    margin-bottom: 40px;
  }
  
  .tab-button {
    padding: 12px 30px;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    background: transparent;
    color: #333;
  }
  
  .tab-button.active {
    background-color: #007bff;
    color: #fff;
  }
  
  /* 内容区域样式 */
  .content-container {
   
    margin: 0 auto;
    overflow: hidden;
    position: relative; /* 使子元素绝对定位相对于此容器 */
  }
  
  .content-wrapper {
    display: flex;
    width: 300%; 
  }
  
  .content-layout {
    display: flex;
    /* gap: 30px; */
    justify-content: center;
    /* padding-left: 5px; */
    align-items: center;
  }
  
  /* 左侧大图新闻样式 */
  .featured-news {
    flex: 0 0 50%;
  }
  
  .image-wrapper {
    width: 100%;
    /* aspect-ratio: 16/9; */
    overflow: hidden;
    float: right;
    /* margin: 0 50px 15px 0; */
  }
  
  .featured-image {
    width: 100%;
    height: 100%;
    max-width: 530px;
    max-height: 298px;
    object-fit: cover;
    border-radius: 30px;
  }
  
  .featured-news h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #1d1d1f;
  }
  
  .featured-news p {
    font-size: 14px;
    color: #6e6e73;
    line-height: 1.6;
  }
  
  /* 右侧新闻列表样式 */
  .news-list {
    width: 50%  ;
    flex: 1;
    margin-top: 10px;
  }
  .news-item-content{
    width: 80%;
  }

  .news-item {
    margin-bottom: 10px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .news-item h3 {
    font-size: 18px;
    /* font-weight: 600; */
    color: #1d1d1f;
  }
  .news-item .date{
 
    font-size: 12px;
    color: #888;
    line-height: 1.6;
    /* position: absolute;
    right: 0;
    top: 0; */
    text-align: right;
  }
  .news-item p {
    font-size: 14px;
    color: #6e6e73;
    line-height: 1.6;
  }
  .more-info-link {
  position: absolute;
  right: 0;
  font-size: 16px;
  color: #1d1d1f;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
}

.more-info-link:hover {
  color: #0056b3;
}
.text-ellipsis {
    white-space: nowrap; /* 强制文本在一行内显示 */
    overflow: hidden;    /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
}
  /* 指示器样式 */
  .carousel-indicators {
    display: flex;
    justify-content: center;
    gap: 8px;
    align-items: center;
    height: 25px;
  }
  
  .carousel-indicators span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ddd;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .carousel-indicators span.active {
    background-color: #333;
    transform: scale(1.2);
  }

  @media (min-width: 1024px) and (max-width: 1366px) {
    .news-tab-section {
      width: 90%;
    }
    .news-list {
      width: 48%;
      margin-left: 2%;
      flex: 1;
      margin-top: 10px;
    }
  .content-layout{
    align-items: center;
  }
  }
  @media (min-width: 769px) and (max-width: 1023px) {
    .news-tab-section {
      width: 90%;
    }
    .tab-button{
      padding: 12px 25px;
    }
    .news-list {
      width: 48%;
      margin-left: 2%;
      flex: 1;
      margin-top: 10px;
    }
    .news-item{
      margin-bottom: 0;
    }
  .content-layout{
    align-items: center;
  }
  }
  /* 添加移动端样式 */
@media screen and (max-width: 768px) {
  .news-tab-section{
    margin-bottom: 0;
    width: 90%;
  }
    .content-container {
    width: 100%;
    overflow: hidden;
    padding-left: 0;

  }
  .content-wrapper {
    display: flex;
    width: fit-content;
    touch-action: pan-y pinch-zoom;
  }

  .mobile-tab {
    flex: 0 0 85vw;
    width: 85vw;
    padding-right: 15px;
  }

  .mobile-layout {
    flex-direction: column;
    gap: 0;
  }

  .featured-news {
    flex: none !important;
    width: 100%;
    margin-bottom: 5px;
  }

  .featured-news .image-wrapper { 
    float: none;
    width: 100%;
    aspect-ratio:4/3;
    border-radius: 8px;
    overflow: hidden;
    margin: 0;
  }

  .news-list {
    flex: none !important;
    width: 100%;
    margin-top: 5px;
  }

  .news-item-content{
    width: 100%;
  }

  .news-item h3 {
  font-size: 18px;
  /* font-weight: 600; */
  color: #333;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示溢出 */
}
.news-item{
  padding: 5px 0;
  margin: 0;
  border-bottom: 1px solid #e4e4e4;
}
.news-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示溢出 */
}
.more-info-link {
    position: static; /* 取消绝对定位 */
    display: block;
    text-align: right;
    margin-bottom: 40px;
    margin-top: 20px;
    color: #007bff;
    font-size: 12px;
  }
  .tabs{
    color: #007bff;
    font-size: 10px;
    border: 1px solid #007bff;
    border-radius: 5px;
    padding: 0 4px;
    margin-right: 10px;
  }
  
}
  </style>